import styled from 'styled-components';
import type { BriefSentiment } from '../../query/fetchMarketSummary';

export const SummaryWrapper = styled('div')`
  ${({ theme }) => theme.typography.small};
  margin-top: ${({ theme }) => theme.x1spacePx}px;
  padding-bottom: ${({ theme }) => theme.x1spacePx}px;

  &:last-child {
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  }

  ul {
    margin-top: ${({ theme }) => theme.x2spacePx}px;
    padding-left: 18px;
    li {
      list-style-type: disc;
      margin-bottom: 12px;
      line-height: 1.5;
    }
    ul {
      margin-top: auto;
      li {
        list-style-type: circle;
        margin-bottom: 12px;
      }
    }
  }
`;

type SummaryTitleProps = {
  readonly sentiment: BriefSentiment;
};

export const SummaryTitle = styled('strong')<SummaryTitleProps>`
  display: block;
  color: ${({ theme, sentiment }) => {
    switch (sentiment) {
      case 'good':
        return theme.color.good;
      case 'bad':
        return theme.color.bad;
      default:
        return theme.color.whiteRGBA(0.6);
    }
  }};
`;
